import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { getHrmsMembers } from 'ducks/member'
import { RequestInformationContainer } from './styled'

const RequestInformation = (props) => {
  const { valueForm, members, memberLoading, change, isDisplay=false } = props
  const [showReqInfo, setShowReqInfo] = useState(true)

  // useEffect(() => {
  //   if (!members.length && !memberLoading) {
  //     props.getHrmsMembers()
  //   }
  // }, [])

  const memberOptions = members.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Request Information'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowReqInfo(!showReqInfo) }>
            {showReqInfo ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showReqInfo}>
        <CardContent>
          <RequestInformationContainer>
            <div className='rowFields'>
              <Field name='title' label='Title' require editable={editableForm()} type={type.text} component={FieldInput} maxLength={200} maxLengthMessage='Title must be less than or equal to 200 characters' tooltip={isDisplay} />
            </div>
            <div className='rowFields'>
              <Field 
                name='requesterUser' 
                label='Requester' 
                require
                editable={editableForm()}
                loading={memberLoading}
                options={memberOptions} 
                type={type.select}
                specialOnChange={(value => {
                  var requester = members.find(m => m.username === value)
                  if (requester) {
                    change('formVendorMaintenance', 'requesterName', `${requester.firstnameEn} ${requester.lastnameEn}`)
                  }
                })}
                component={FieldInput} />
              <Field 
                name='documentDate' 
                label='Document Date' 
                editable={editableForm()} 
                require 
                type={type.date} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='remark' 
                label='Remark' 
                editable={editableForm()} 
                type={type.textArea} 
                component={FieldInput} 
              />
            </div>
            {
              valueForm.status ? 
              <div className='rowFields'>
                <Field 
                  name='submittedDate' 
                  label='Submitted Date' 
                  dateFormat='dd MMMM yyyy HH:mm:ss'
                  editable={false}  
                  type={type.date} 
                  component={FieldInput} 
                />
                <Field 
                  name='modifiedDate' 
                  label='Modified Date' 
                  dateFormat='dd MMMM yyyy HH:mm:ss'
                  editable={false}  
                  type={type.date} 
                  component={FieldInput} 
                />
              </div> : null
            }
            
          </RequestInformationContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    members: state.member.members,
    memberLoading: state.member.memberLoading
  })
}
  

const mapDispatchToProps = {
  getHrmsMembers
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestInformation)
